// assets/service-config.js
// Catálogo de productos con servicio de instalación
// servicios: [[sin_hub], [con_hub]]
// posiciones dentro del subarray: [0]Madera, [1]Aluminio, [2]Cristal, [3]Metal
// mostrar_preguntas: true  → muestra pregunta de material al usuario
// mostrar_preguntas: false → toma servicios[0][0] automáticamente

window._CONFIG_SERVICIOS = [

  // ── CERRADURAS BÁSICAS ─────────────────────────────────────────────────────

  { id_articulo: 401,    nombre: 'Cerradura YMF 40A',
    mostrar_preguntas: true,
    servicios: [[102, 158, 159, 104], [103, 160, 161, 105]],
    espesor: '35 a 90 mm' },

  { id_articulo: 396,    nombre: 'Cerrojo YDF 40A',
    mostrar_preguntas: true,
    servicios: [[98, 172, 155, 157], [99, 161, 157, 101]],
    espesor: '35 a 55 mm' },

  { id_articulo: 393,    nombre: 'Real Living YRL226',
    mostrar_preguntas: true,
    servicios: [[98, 172, 155, 157], [99, 161, 157, 101]],
    espesor: '35 a 45 mm' },

  { id_articulo: 394,    nombre: 'Real Living YRD226',
    mostrar_preguntas: true,
    servicios: [[98, 172, 155, 157], [99, 161, 157, 101]],
    espesor: '35 a 45 mm' },

  { id_articulo: 400,    nombre: 'Real Living YRD110',
    mostrar_preguntas: true,
    servicios: [[98, 154, 155, 100], [99, 156, 157, 101]],
    espesor: '35 a 45 mm' },

  { id_articulo: 397,    nombre: 'Assure YRD256',
    mostrar_preguntas: true,
    servicios: [[98, 172, 155, 157], [99, 161, 157, 101]],
    espesor: '35 a 55 mm' },

  { id_articulo: 392,    nombre: 'eButton YDD114',
    mostrar_preguntas: true,
    servicios: [[98, 154, 155, 100], [99, 156, 157, 101]],
    espesor: '35 a 45 mm' },

  { id_articulo: 399,    nombre: 'XTR Phillips',
    mostrar_preguntas: true,
    servicios: [[98, 154, 155, 100], [99, 156, 157, 159]],
    espesor: '35 a 45 mm en Madera ó 25 a 45 mm en Metal' },

  { id_articulo: 405,    nombre: 'X86A Tesa',
    mostrar_preguntas: true,
    servicios: [[98, 154, 155, 100], [99, 156, 157, 159]],
    espesor: '35 a 50 mm' },

  { id_articulo: 676,    nombre: '321 Phillips',
    mostrar_preguntas: true,
    servicios: [[98, 154, 155, 100], [99, 156, 157, 159]],
    espesor: '35 a 50 mm' },

  // ── KIT HUB ────────────────────────────────────────────────────────────────

  { id_articulo: 678,    nombre: 'Kit HUB Yale Connect',
    mostrar_preguntas: false,
    servicios: [[162], []],
    espesor: '' },

  // ── NEXTOUCH ───────────────────────────────────────────────────────────────

  { id_articulo: 398,    nombre: 'Nextouch',
    mostrar_preguntas: true,
    servicios: [[166, 168, 155, 167], [169, 171, 157, 170]],
    espesor: '35 a 45 mm' },

  // ── CASTELLI ───────────────────────────────────────────────────────────────

  { id_articulo: 109083, nombre: 'Castelli Biométrica',
    mostrar_preguntas: true,
    servicios: [[98, 154, 0, 100], [99, 156, 157, 101]],
    espesor: '35 a 45 mm' },

  // ── YSD 100 ────────────────────────────────────────────────────────────────

  { id_articulo: 210728, nombre: 'YSD 100 2885',
    mostrar_preguntas: true,
    servicios: [[384, 385, 0, 0], [99, 156, 157, 101]],
    espesor: '25 a 45 mm' },

  { id_articulo: 210729, nombre: 'YSD 100 5085',
    mostrar_preguntas: true,
    servicios: [[384, 385, 0, 387], [99, 156, 157, 101]],
    espesor: '25 a 65 mm' },

  { id_articulo: 243387, nombre: 'YSD100 SMART',
    mostrar_preguntas: true,
    servicios: [[384, 385, 0, 387], [623, 624, 0, 624]],
    espesor: '25 a 65 mm' },

  // ── ASSURE ─────────────────────────────────────────────────────────────────

  { id_articulo: 210727, nombre: 'Assure YXR256',
    mostrar_preguntas: true,
    servicios: [[388, 389, 0, 390], [418, 420, 157, 419]],
    espesor: '35 a 55 mm' },

  { id_articulo: 397,    nombre: 'Assure YRD256 (embutir)',
    mostrar_preguntas: true,
    servicios: [[102, 158, 159, 104], [103, 160, 161, 105]],
    espesor: '35 a 55 mm' },

  // ── YMC ────────────────────────────────────────────────────────────────────

  { id_articulo: 240446, nombre: 'YMC420',
    mostrar_preguntas: true,
    servicios: [[609, 611, 0, 611], [610, 612, 0, 612]],
    espesor: '35 a 55 mm' },

  { id_articulo: 240447, nombre: 'Cerradura YMC300',
    mostrar_preguntas: true,
    servicios: [[609, 611, 0, 611], [610, 612, 0, 612]],
    espesor: '35 a 70 mm' },

  // ── PCD ────────────────────────────────────────────────────────────────────

  { id_articulo: 217848, nombre: 'Perilla PCD275',
    mostrar_preguntas: true,
    servicios: [[245, 315, 0, 315], [99, 161, 157, 101]],
    espesor: '35 a 45 mm' },

  { id_articulo: 1778,   nombre: 'Manija PCD285',
    mostrar_preguntas: true,
    servicios: [[245, 315, 0, 315], [99, 161, 157, 101]],
    espesor: '35 a 45 mm' },

  { id_articulo: 218126, nombre: 'Cerrojo PCD265',
    mostrar_preguntas: true,
    servicios: [[245, 315, 0, 315], [99, 161, 157, 101]],
    espesor: '35 a 45 mm' },

  // ── OTROS ──────────────────────────────────────────────────────────────────

  { id_articulo: 210726, nombre: 'Cerrojo YDD120',
    mostrar_preguntas: true,
    servicios: [[98, 154, 0, 100], [0, 0, 0, 0]],
    espesor: '35 a 45 mm' },

  { id_articulo: 216520, nombre: 'YXR226',
    mostrar_preguntas: true,
    servicios: [[388, 389, 0, 390], [418, 420, 0, 419]],
    espesor: '35 a 55 mm' },

  { id_articulo: 243386, nombre: 'YDM60',
    mostrar_preguntas: true,
    servicios: [[102, 158, 0, 104], [103, 160, 0, 105]],
    espesor: '45 a 100 mm' },

  { id_articulo: 216519, nombre: 'Assure YRD256 (embutir B)',
    mostrar_preguntas: true,
    servicios: [[102, 158, 159, 104], [103, 160, 161, 105]],
    espesor: '35 a 55 mm' },

  { id_articulo: 325039, nombre: 'JULIUS',
    mostrar_preguntas: true,
    servicios: [[102, 104, 158, 0], [0, 0, 0, 0]],
    espesor: '45 a 100 mm' },

  { id_articulo: 325040, nombre: 'CORNELIUS',
    mostrar_preguntas: true,
    servicios: [[102, 104, 158, 0], [0, 0, 0, 0]],
    espesor: '45 a 100 mm' },


  //---REGISTROS NUEVOS

  { id_articulo: 216521, nombre: 'Real Living Manija NS',
    mostrar_preguntas: true,
    servicios: [[102, 104, 158, 0], [0, 0, 0, 0]],
    espesor: '45 a 100 mm' },

  { id_articulo: 216522, nombre: 'Real Living Cerrojo NS',
    mostrar_preguntas: true,
    servicios: [[102, 104, 158, 0], [0, 0, 0, 0]],
    espesor: '45 a 100 mm' },

  { id_articulo: 358799, nombre: 'YSD100 + HUB 2885 GUN METAL',
    mostrar_preguntas: true,
    servicios: [[102, 104, 158, 0], [0, 0, 0, 0]],
    espesor: '45 a 100 mm' },

  { id_articulo: 350281, nombre: 'CERRADURA DIG PCD140 PHILLIPS ANE',
    mostrar_preguntas: true,
    servicios: [[102, 104, 158, 0], [0, 0, 0, 0]],
    espesor: '45 a 100 mm' },

  { id_articulo: 344979, nombre: 'CERRADURA DIG CORNELIUS YALE',
    mostrar_preguntas: true,
    servicios: [[102, 104, 158, 0], [0, 0, 0, 0]],
    espesor: '45 a 100 mm' },

  { id_articulo: 344880, nombre: 'CERRADURA DIG JULIUS YALE',
    mostrar_preguntas: true,
    servicios: [[102, 104, 158, 0], [0, 0, 0, 0]],
    espesor: '45 a 100 mm' },

  { id_articulo: 345359, nombre: 'CERRADURA DIG ARUMA PHILLIPS',
    mostrar_preguntas: true,
    servicios: [[102, 104, 158, 0], [0, 0, 0, 0]],
    espesor: '45 a 100 mm' },

  { id_articulo: 346601, nombre: 'CERROJO DIG BALAK NE PHILLIPS',
    mostrar_preguntas: true,
    servicios: [[102, 104, 158, 0], [0, 0, 0, 0]],
    espesor: '45 a 100 mm' },

  { id_articulo: 347781, nombre: 'CERRADURA DIG COMPACT MAN KIT',
    mostrar_preguntas: true,
    servicios: [[102, 104, 158, 0], [0, 0, 0, 0]],
    espesor: '45 a 100 mm' },

  { id_articulo: 344981, nombre: 'CERRADURA DIG COMPACT CERR KIT',
    mostrar_preguntas: true,
    servicios: [[102, 104, 158, 0], [0, 0, 0, 0]],
    espesor: '45 a 100 mm' },

  { id_articulo: 345869, nombre: 'CERRADURA DIG GEMINI MINI KIT',
    mostrar_preguntas: true,
    servicios: [[102, 104, 158, 0], [0, 0, 0, 0]],
    espesor: '45 a 100 mm' },

  { id_articulo: 344983, nombre: 'CERRADURA DIG GEMINI KIT',
    mostrar_preguntas: true,
    servicios: [[102, 104, 158, 0], [0, 0, 0, 0]],
    espesor: '45 a 100 mm' },

];